// Returns a shallow copy of `obj` with null/undefined values removed.
// Useful for spreading optional fields onto GQL input objects without sending explicit nulls.
export const pickDefined = <T extends object>(obj: T): Partial<T> =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => v != null)) as Partial<T>;

// Builds a normalizer function for a string enum. The map must have lowercase keys
// mapping to the canonical enum values. The returned function accepts any string and
// returns the canonical value if a case-insensitive match exists, otherwise returns
// the input unchanged.
export function makeEnumNormalizer<T extends string>(lowerMap: Map<string, T>): (v: string) => T {
  const values = new Set(lowerMap.values());
  return (v: string): T => (values.has(v as T) ? (v as T) : lowerMap.get(v.toLowerCase()) ?? (v as T));
}
